import React from "react";
import { Container, Button, Row, Col } from "react-bootstrap";

export const HeroSection = () => {
  return (
    <section
      style={{ backgroundColor: "#2959A5" }}
      className="py-5 text-center"
    >
      <Container style={{ maxWidth: "960px" }}>
        <h1
          className="display-5 fw-bold mb-4"
          style={{ color: "#FFFFFF" }}
        >
          Let Us Build Your Event Calendar – So You Can Focus on What You Do Best
        </h1>

        <p
          className="lead mb-4"
          style={{ color: "#FFFFFF" }}
        >
          Tired of spending hours on event applications with no guarantee of return? With AMFVG’s Vendor Scheduler, we handle the admin work and boost your event success — all starting from just $25 per application.
        </p>

        <h4
          className="fw-bold mb-3"
          style={{ color: "#FFFFFF" }}
        >
          Here’s how it works:
        </h4>

        <Row className="justify-content-center text-start mb-4">
          <Col md={6}>
            <ul style={{ lineHeight: "1.6", color: "#FFFFFF", paddingLeft: "1rem" }}>
              <li>We act as your dedicated event coordinator using AI, data, and expertise</li>
              <li>Search for events suited to your truck's style and goals</li>
              <li>Apply on your behalf using tokens you purchase</li>
              <li>Provide tailored recommendations after strategy discussions</li>
            </ul>
          </Col>
          <Col md={6}>
            <ul style={{ lineHeight: "1.6", color: "#FFFFFF", paddingLeft: "1rem" }}>
              <li>Populate your calendar with confirmed bookings week-by-week</li>
              <li>Forecast sales using crowd data and event history</li>
              <li>Help you prioritise events if multiple happen on the same day</li>
            </ul>
          </Col>
        </Row>

        <p
          className="lead mb-3"
          style={{ color: "#FFFFFF" }}
        >
          Only a <strong>$100 success fee per approved application</strong> — we’re motivated to get you into the right events, not just any event.
        </p>

        <Button
          variant="danger"
          style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
          className="px-5 py-3 rounded-pill fw-semibold"
        >
          Buy Tokens
        </Button>
      </Container>
    </section>
  );
};
